import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import SimpleBarReact from 'simplebar-react';

import { alpha, useTheme } from '@mui/material/styles';
import { Box, useMediaQuery } from '@mui/material';

const Scrollbar = forwardRef((props, ref) => {
  const { children, sx, scrollableNodeProps, ...other } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <Box className="scrollbar-box" ref={ref} sx={{ overflowX: 'auto', ...sx }} {...other}>
        {children}
      </Box>
    );
  }

  return (
    <Box className="scrollbar" sx={{ ...styleWrapper(theme), ...sx }}>
      <SimpleBarReact
        className="simplebar-react"
        ref={ref}
        timeout={500}
        clickOnTrack={false}
        scrollableNodeProps={scrollableNodeProps}
        {...other}
      >
        {children}
      </SimpleBarReact>
    </Box>
  );
});

const styleWrapper = (theme) => ({
  flexGrow: 1,
  height: '100%',
  overflow: 'auto',
  '.simplebar-react': {
    maxHeight: '100%',
    '& .simplebar-placeholder': {
      display: 'none', // Empêche la placeholder de prendre de l'espace
      position: 'absolute', // Sort l'élément du flux
      height: 0 // Réduit la hauteur au minimum
    },
    '& .simplebar-scrollbar': {
      '&:before': {
        backgroundColor: alpha(theme.palette.grey[600], 0.48)
      },
      '&.simplebar-visible:before': {
        opacity: 1
      }
    },
    '& .simplebar-track.simplebar-vertical': {
      width: 10
    },
    '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': {
      height: 6
    },
    '& .simplebar-mask': {
      zIndex: 'inherit'
    }
  }
});

Scrollbar.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
  scrollableNodeProps: PropTypes.object
};

export default Scrollbar;
